module.exports = __webpack_public_path__ + "23b69e977516a74165b76ac0bdf42668.jpg";